import React, { createContext, useState } from 'react'

export interface MachineObjectType {
  id: number | null
  identification: string
  model: string
  costPerHour: string
  unitOfMeasure:string
  format: string
  productionCapacityMin: number | null
  productionCapacityMax: number | null
  weight: number | null
  height: number | null
  width: number | null
  length: number | null
  lastMaintenance: string | any
  nextMaintenance: string | any
  functions: any[]
}

export const initialMachineState: MachineObjectType = {
  id: null,
  identification: '',
  model: '',
  costPerHour: '',
  unitOfMeasure:'',
  format: '',
  productionCapacityMin: null,
  productionCapacityMax: null,
  weight: null,
  height:null,
  width:null,
  length:null,
  lastMaintenance: '',
  nextMaintenance: '',
  functions:[]
}

interface MachineContextProps {
  machine: MachineObjectType
  setMachine: React.Dispatch<React.SetStateAction<MachineObjectType>>
}

export const MachineContext = createContext<MachineContextProps>({
  machine: initialMachineState,
  setMachine: () => { return }
})

export const MachineProvider: React.FC<any> = ({ children }) => {
  const [machine, setMachine] = useState<MachineObjectType>(initialMachineState)

  return (
    <MachineContext.Provider value={{
      machine: machine,
      setMachine: setMachine
    }}>
      {children}
    </MachineContext.Provider>
  )
}
